<template>
    <app-layout :title="'Survey: ' + surveyModel.name" :survey-layout="true">
        <div class="mt-6 mb-11 flex justify-between items-center">
            <h2 class="font-bold text-4xl dark:text-gray-200">
                {{ surveyModel.name }}
            </h2>
        </div>
        <div class="p-6 shadow-md rounded-md mb-10">
            <p class="text-lg font-bold">
                {{ message }}
            </p>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
export default {
    name: "SurveyMessage",
    components: {AppLayout},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        },
        message: {
            type: String,
            required: true,
        }
    },
}
</script>

<style scoped>

</style>
